import React from "react";
import "./style.css";
const NavTab = ({ label, icon, active = false, onClick }) => {
  return (
    <div
      className={`nav-tab ${active ? "active-btn-tab" : ""} `}
      onClick={() => {
        onClick();
      }}
    >
      <div>
        <img
          style={{
            width: label === "Extension" || label === "Enrich" ? "25px" : "",
            marginRight:
              label === "Extension" || label === "Enrich" ? "10px" : "",
            marginLeft:
              label === "Extension" || label === "Enrich" ? "10px" : "",
          }}
          src={icon}
          alt=""
          srcset=""
        />
      </div>
      <div>
        <h6>{label}</h6>
      </div>
    </div>
  );
};

export default NavTab;
